export default __webpack_public_path__ + "static/media/alert_icon.2487a248.svg";